
import api from 'frontend/api';

export default {
	async fetchOrderList({ commit }, params)
	{
		var result = await api.get('/orders', { params });
		commit('setOrderList', result.data.orders);
		return result.data;
	},

	async fetchOrder({ commit }, id)
	{
		var result = await api.get(`/orders/${id}`);
		commit('setCurrentOrder', result.data.order);
	}
}